function Hero() {
    return (<div className="text-left px-4 md:px-8 lg:px-12 mt-1 md:mt-10 lg:mt-10 pt-2 md:pt-2 lg:pt-2 pb-5">
            {/* Text container with semi-transparent background */}
            <div className="bg-black/40 p-4 md:p-6 rounded-lg backdrop-blur-sm inline-block max-w-3xl">
                <h1 className="hero-section-header">
                    Empower your home <br className="hidden sm:block"/>
                    with solar
                    <span className="text-yellow-400"> energy</span>
                </h1>
                <p className="hero-section-para">
                    At <span className="text-sky-300">Solar Made Easy</span>, we simplify the transition to solar energy
                    with
                    expert <br className="hidden md:block"/> installation and comprehensive
                    maintenance services tailored to your needs.
                </p>
                <div className=" flex flex-wrap gap-4 justify-center">
                    <button className="hero-section-learn-more">Learn More</button>
                </div>
            </div>
        </div>);
}

export default Hero;
